import { render, staticRenderFns } from "./TemplatesPage.vue?vue&type=template&id=53bb5cd9&scoped=true"
import script from "./TemplatesPage.vue?vue&type=script&lang=ts"
export * from "./TemplatesPage.vue?vue&type=script&lang=ts"
import style0 from "./TemplatesPage.vue?vue&type=style&index=0&id=53bb5cd9&prod&lang=scss"
import style1 from "./TemplatesPage.vue?vue&type=style&index=1&id=53bb5cd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bb5cd9",
  null
  
)

export default component.exports